import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingFlag: 0,
  departmentList: [],
};

export const departmentSlice = createSlice({
  name: "department",
  initialState,
  reducers: {
    // Loading flag increment
    setLoadingFlagIncrement: (state) => {
      state.loadingFlag = state.loadingFlag + 1;
    },
    // Loading flag decrement
    setLoadingFlagDecrement: (state) => {
      if (state.loadingFlag !== 0) {
        state.loadingFlag = state.loadingFlag - 1;
      }
    },
    setDepartmentList: (state, action) => {
      state.departmentList = action.payload;
    },
  },
});

export const {
  setLoadingFlagIncrement,
  setLoadingFlagDecrement,
  setDepartmentList,
} = departmentSlice.actions;

export default departmentSlice.reducer;
